import api from '@/store/api';
import { athena, boro } from '@/store/api/instances';
import type { CashVaultBranch } from '@/types/configs';
import type { ApiListingRequest, ApiResponse } from '@bitstopco/bitstop-theme';

interface CreateCashVaultBranchRequest {
  name: string;
  description: string;
}

interface UpdateCashVaultBranchRequest {
  id: string;
  name: string;
  description: string;
  is_active?: boolean;
}

/**
 * RTK Query API for Cash Vault Branches.
 */
export const cashVaultBranchesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCashVaultBranches: build.query<ApiResponse<CashVaultBranch[]>, ApiListingRequest | void>({
      query: (data) =>
        athena({
          url: 'v2/operations/cash-vault-branches',
          method: 'POST',
          data: data || {
            pagination: {
              current_page: 1,
              items_per_page: 1000,
              sort_by: 'name',
              sort_ascending: true,
            },
          },
        }),
      providesTags: ['CashVaultBranches'],
    }),
    createCashVaultBranch: build.mutation<
      ApiResponse<CashVaultBranch>,
      CreateCashVaultBranchRequest
    >({
      query: (data) =>
        boro({
          url: 'v2/operations/cash-vault-branches',
          method: 'POST',
          data,
        }),
      invalidatesTags: ['CashVaultBranches'],
    }),
    updateCashVaultBranch: build.mutation<
      ApiResponse<CashVaultBranch>,
      UpdateCashVaultBranchRequest
    >({
      query: ({ id, ...data }) =>
        boro({
          url: `v2/operations/cash-vault-branches/${id}`,
          method: 'PATCH',
          data,
        }),
      invalidatesTags: ['CashVaultBranches'],
    }),
    deleteCashVaultBranch: build.mutation<void, string>({
      query: (id) =>
        boro({
          url: `v2/operations/cash-vault-branches/${id}`,
          method: 'DELETE',
        }),
      invalidatesTags: ['CashVaultBranches'],
    }),
  }),
});

export const {
  useGetCashVaultBranchesQuery,
  useCreateCashVaultBranchMutation,
  useUpdateCashVaultBranchMutation,
  useDeleteCashVaultBranchMutation,
} = cashVaultBranchesApi;
